export const BulkEditProgramSiteCoreKeys = {
  bulkProcessDetails:
    "ProgramsAndParticipant.BulkEditProgram.BulkProcessDetails",
  selectType: "BulkEditProgram.BulkProcessDetails.SelectType",
  chooseParticipants:
    "BulkEditProgram.BulkProcessDetails.ChooseParticipantsAndDownloadTemplateRadioButton",
  uploadModifiedTemplate:
    "BulkEditProgram.BulkProcessDetails.UploadModifiedTemplateRadioButton",
};

export const bulkEditProgramSearchParticipantKeys = {
  searchParticipantsKey:
    "ProgramsAndParticipant.BulkEditProgram.SearchParticipants",
  client: "BulkEditProgram.SearchParticipants.Client",
  deliveryCountry: "BulkEditProgram.SearchParticipants.DeliveryCountry",
  participantStatus: "BulkEditProgram.SearchParticipants.ParticipantStatus",
  productLine: "BulkEditProgram.SearchParticipants.ProductLine",
  programTemplate: "BulkEditProgram.SearchParticipants.ProgramTemplate",
  participantStatusList:
    "BulkEditProgram.SearchParticipants.ParticipantStatusList",
};

export const bulkEditSearchParticipantResultsSiteCoreKeys = {
  participantsResultsKey:
    "ProgramsAndParticipant.BulkEditProgram.ParticipantsResults",
  allParticipantsSectionTitle:
    "BulkEditProgram.ParticipantsResults.AllParticipantsSectionTitle",
  cancelProcessConfirmationMessage:
    "BulkEditProgram.ParticipantsResults.CancelProcessConfirmationMessage",
  chooseParticipantsSectionSubTitle:
    "BulkEditProgram.ParticipantsResults.ChooseParticipantsSectionSubTitle",
  clientName: "BulkEditProgram.ParticipantsResults.ClientName",
  createdDate: "BulkEditProgram.ParticipantsResults.CreatedDate",
  deliveryCountry: "BulkEditProgram.ParticipantsResults.DeliveryCountry",
  programKey: "BulkEditProgram.ParticipantsResults.ProgramKey",
  participantEmail: "BulkEditProgram.ParticipantsResults.ParticipantEmail",
  participantName: "BulkEditProgram.ParticipantsResults.ParticipantName",
  participantsSectedDropDownText:
    "BulkEditProgram.ParticipantsResults.ParticipantsSectedDropDownText",
  productLine: "BulkEditProgram.ParticipantsResults.ProductLine",
  programStatus: "BulkEditProgram.ParticipantsResults.ProgramStatus",
  programTemplate: "BulkEditProgram.ParticipantsResults.ProgramTemplate",
  selectClientToCountinueMessage:
    "BulkEditProgram.ParticipantsResults.SelectClientToCountinueMessage",
  selectAtLeastTwoParticipantsMessage:
    "BulkEditProgram.ParticipantsResults.SelectAtLeatTwoParticipantsMessage",
  participantStatusList:
    "BulkEditProgram.ParticipantsResults.ParticipantStatusList",
};

export const bulkEditHeaderFooterSiteCoreKeys = {
  headerAndFooterComponent:
    "ProgramsAndParticipant.BulkEditProgram.HeaderandFooterComponent",
  chooseParticipantsAndDownloadTemplateTypeSubTitle:
    "BulkEditProgram.HeaderandFooterComponent.ChooseParticipantsAndDownloadTemplateTypeSubTitle",
  downloadSmartTemplate:
    "BulkEditProgram.HeaderandFooterComponent.DownloadSmartTemplate",
  uploadModifiedTemplateTypeSubTitle:
    "BulkEditProgram.HeaderandFooterComponent.UploadModifiedTemplateTypeSubTitle",
};
